import React from "react";
import BulkSummaryCards from "../payrole-tabs/BulkSummaryCards";
import GenerateBankFile from "../payrole-tabs/GenerateBankFile";
import GeneratedBankFilesTable from "../payrole-tabs/GeneratedBankFilesTable";

const BankFiles = () => {
  const statsData = {
    eligible: {
      label: "Eligible",
      value: 18,
      subtitle: "employees",
      type: "eligible",
    },
    payout: {
      label: "Total Payout",
      value: 0,
      subtitle: "for selected",
      type: "payout",
      isCurrency: true,
    },
    processed: {
      label: "Processed",
      value: 0,
      subtitle: "employees",
      type: "processed",
    },
  };

  return (
    <div className="pp-wrapper pp-bank-files-container">
      <BulkSummaryCards statsData={statsData} />

      <GenerateBankFile />

      <GeneratedBankFilesTable />
    </div>
  );
};

export default BankFiles;
